import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import FavoriteStarButton from '../../../components/favorites/FavoriteStarButton';
import { FAVORITE_TYPE_USER } from '../../../services/favoriteModelsService';
import { cn } from '../../../utils/cn';
import { DOCUMENT_TITLE_WRAP_CLASS } from '../../../utils/documentTitle';

const formatDateTime = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const TemplateTableRow = ({
  template,
  onEdit,
  onCreateContract,
  onDelete,
  onDuplicate,
  onDownload,
  actionsDisabled = false,
}) => {
  const canDownload =
    Boolean(template.templateKey ?? template.template_key) &&
    String(template.docx_status ?? '').toUpperCase() === 'GENERATED';

  return (
    <tr className="list-item-hover border-l-4 border-muted-foreground/40">
      <td className="px-4 md:px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 rounded-lg flex-shrink-0 bg-muted/50">
            <Icon
              name="LayoutTemplate"
              size={20}
              className="text-muted-foreground"
            />
          </div>

          <div className="min-w-0">
            <p
              className={cn(
                'text-sm font-medium text-foreground font-body',
                DOCUMENT_TITLE_WRAP_CLASS
              )}
              title={template.name}
            >
              {template.name}
            </p>
            {template.description ? (
              <p className="text-xs text-muted-foreground font-caption truncate mt-0.5">
                {template.description}
              </p>
            ) : null}
          </div>
        </div>
      </td>

      <td className="px-4 md:px-6 py-4 hidden md:table-cell">
        <p className="text-sm text-foreground font-body">
          {formatDateTime(template.created_at)}
        </p>
      </td>

      <td className="px-4 md:px-6 py-4 text-right">
        <div className="flex items-center justify-end gap-2 flex-wrap">
          <FavoriteStarButton
            type={FAVORITE_TYPE_USER}
            id={template.template_id ?? template.id}
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="FilePlus"
            onClick={() => onCreateContract(template)}
            disabled={actionsDisabled}
            className="transition-transform hover:scale-110"
            aria-label="Gerar documento com este modelo"
            title="Gerar documento"
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Download"
            onClick={() => onDownload(template)}
            disabled={actionsDisabled || !canDownload}
            className="transition-transform hover:scale-110"
            aria-label="Baixar modelo DOCX"
            title="Baixar modelo DOCX"
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Edit"
            onClick={() => onEdit(template)}
            disabled={actionsDisabled}
            className="transition-transform hover:scale-110"
            aria-label="Editar modelo"
            title="Editar modelo"
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Copy"
            onClick={() => onDuplicate(template)}
            disabled={actionsDisabled}
            className="transition-transform hover:scale-110"
            aria-label="Duplicar modelo"
            title="Duplicar modelo"
          />

          <Button
            variant="ghost"
            size="sm"
            iconName="Trash2"
            onClick={() => onDelete(template)}
            disabled={actionsDisabled}
            className="text-destructive hover:text-destructive transition-transform hover:scale-110"
            aria-label="Excluir modelo"
            title="Excluir modelo"
          />
        </div>
      </td>
    </tr>
  );
};

export default TemplateTableRow;
